import React from 'react';
import { VersionSwitcher } from 'components/allocation-manager/version-switcher';
import { DevelopmentAreaVersionsResponse } from 'types/api-responses';
import { Page } from 'pages/development-areas/show/types';
import style from 'pages/development-areas/show/page.module.scss';

interface Props {
  developmentAreaVersions: DevelopmentAreaVersionsResponse;
  page: Page;
  setPage: (page: Page) => void;
}

export const DevelopmentAreasVersionSwitcher: React.FC<Props> = ({
  developmentAreaVersions,
  page,
  setPage,
}) => {
  const currentVersion = developmentAreaVersions.find(
    (version) => page.majorVersionNumber === version.majorVersionNumber
  );

  const renderVersionLabel = (version: DevelopmentAreaVersionsResponse[0]) => {
    return (
      <div className={style.versionMenuItemContent}>
        <span style={{ whiteSpace: 'nowrap' }}>
          {version.versionName}&nbsp;
          <span>({version.versionDisplayTime})</span>
        </span>
      </div>
    );
  };

  return (
    <div className={style.versionSwitcherContainer}>
      <VersionSwitcher
        items={developmentAreaVersions}
        selectedItem={currentVersion || developmentAreaVersions[0]}
        onChange={(selectedVersion) => {
          setPage({
            href: selectedVersion.href,
            majorVersionNumber: selectedVersion.majorVersionNumber,
          });
        }}
        getItemKey={(version) => version.versionName}
        renderItemLabel={renderVersionLabel}
        menuClassName="versionSwitcherMenu"
        menuOptionsClassName="versionSwitcherOptions"
      />
    </div>
  );
};
